export var Answer;
(function (Answer) {
    Answer[Answer["Yes"] = 1] = "Yes";
    Answer[Answer["MostlyYes"] = 2] = "MostlyYes";
    Answer[Answer["MostlyNo"] = 3] = "MostlyNo";
    Answer[Answer["No"] = 4] = "No";
    Answer[Answer["NotRelevant"] = -1] = "NotRelevant";
})(Answer || (Answer = {}));
